import { MutationCache } from '@tanstack/react-query';
import { toast } from 'sonner';

import {
  SegmentMutationMeta,
  trackMutationFailure,
  trackMutationSuccess,
} from '@/segment/segmentMutations';

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: {
      segment?: SegmentMutationMeta;
      /**
       * Show the error's message as a toast when the mutation fails. Opt-in, so a mutation
       * that handles its own errors, or fails silently on purpose, is left alone.
       */
      errorToast?: boolean;
    };
  }
}

/**
 * Builds the app's mutation cache: behaviour a mutation declares in `meta` instead of writing an
 * `onSuccess` / `onError` for it. A factory so each QueryClient, a test's included, gets its own.
 *
 * ```ts
 * useMutation({ mutationFn, meta: { errorToast: true } })
 * ```
 */
export const createMutationCache = () =>
  new MutationCache({
    onSuccess: trackMutationSuccess,
    onError: (...args) => {
      trackMutationFailure(...args);
      const [error, , , mutation] = args;
      if (mutation.meta?.errorToast) {
        toast.error(error.message);
      }
    },
  });
